// extracted by mini-css-extract-plugin
export default {"history":"styles_history__Q9Coj","selected":"styles_selected__m3Gr6"};